module.exports = __webpack_public_path__ + "img/img (32).bd601103.jpg";